/**
 * Naive local time-of-day (wall clock) bounds for the booking-update widen flow.
 * The customer UI constrains pickers to this band on the service date; backend no longer sends widen_local_band_*.
 */
export const BOOKING_UPDATE_OFFER_WIDEN_LOCAL_BAND_START = '06:00:00';
export const BOOKING_UPDATE_OFFER_WIDEN_LOCAL_BAND_END = '23:00:00';
